function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref3 = /*#__PURE__*/React.createElement("title", null, "Edit");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, React.createElement("g", {
  id: "4.4c\\u2013-User-\\u2013-Library-\\u2013-Default-Overlay-option-2-Copy",
  transform: "translate(-921.000000, -301.000000)",
  stroke: "#636363"
}, React.createElement("g", {
  id: "Group-5",
  transform: "translate(117.000000, 136.000000)"
}, React.createElement("g", {
  id: "Group-8",
  transform: "translate(28.000000, 38.000000)"
}, React.createElement("g", {
  id: "blake-barlow-1499548-unsplash",
  transform: "translate(277.000000, 98.000000)"
}, React.createElement("g", {
  id: "Group-4",
  transform: "translate(-0.000000, 0.000000)"
}, React.createElement("path", {
  d: "M510.01535,30.3169755 L510.541265,30.7935073 C511.152912,31.3477203 511.152912,32.2462771 510.541265,32.8004901 L502.740882,39.8684211 L500,39.8684211 L500,37.3849065 L507.800383,30.3169755 C508.412029,29.7627625 509.403704,29.7627625 510.01535,30.3169755 Z M506.852205,31.1761201 L509.593087,33.6596346 L506.852205,31.1761201 Z",
  id: "Shape"
})))))));

const SvgEdit = (_ref) => {
  let svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "13px",
    height: "12px",
    viewBox: "0 0 13 12",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgEdit, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/edit.d7f57582.svg";
export { ForwardRef as ReactComponent };